// Which details panel the right-hand drawer shows. Kept in its own leaf module
// (rather than alongside the DetailsPanel component) so pure helpers and tests
// can depend on the enum without pulling in the component tree.
export enum PanelType {
  ORDER_DETAILS = 'orderDetails',
  ROUTE_DETAILS = 'routeDetails',
}
